/**
 * The app and its version, as the apps tell vision-api in `X-Creavision-App` (VisionPlatform usage-metrics UM-02):
 * `web/<version>`. The version is `VITE_APP_VERSION` at build time when the release sets it, otherwise the UTC build
 * date as `YYYY.MM.DD` (vite.config.ts).
 */
export const APP_VERSION: string = __APP_VERSION__;

/** The value of `X-Creavision-App` on every API request. */
export const APP_HEADER = `web/${APP_VERSION}`;
